module.exports = __webpack_public_path__ + "static/media/wand-magic.77a83db6.svg";